import React from "react";
import WebPageTopics from "../../topics/WebPageTopics";


function ChapterWiseWeightagePhysTopics() {


  return (
    <>

      <WebPageTopics subject="physics" type="chapterwiseweightage" />

    </>
  );
}

export default ChapterWiseWeightagePhysTopics;